<!--  -->
<template>
  <div>
    <van-popup v-model="show" position="bottom" :style="{ height: '82%' }" duration="0.18"
      :close-on-click-overlay="false">
      <div class="title">
        <p>请选择课程</p>
        <van-icon name="cross" @click="onClose" />
      </div>
      <div class="content">
        <div class="content-box">
          <div class="mandatory">
            <div class="mandatory-box" v-for="(item, index) in mandatoryCourse" :key="index">
              <SelectCourseCard :courseInfo="item" @skuInfo="skuInfo" />
            </div>
          </div>
          <div class="optional" v-for="(child, index) in optionCourse" :key="index">
            <div class="group-name">
              <p>{{ child.groupInfo.name }}</p>
              <span>以下课程选择{{ showNum(child.groupInfo.selectProductNum) }}门</span>
            </div>
            <ul class="optional-course">
              <li :class="{
                active: item.isSelect,
                disbaled: (child.disbaled && !item.isSelect) || item.disaled,
              }" v-for="(item, idx) in child.productSkuList" :key="idx" @click="chooseCourse(item, index, idx)">
                <p class="ellipsis">
                  {{ item.name }}
                </p>
                <img :src="checkIcon" alt="" />
                <span>{{ String(item.skuName) }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="foot">
        <div class="foot-box" @click="toBuy" v-if="buyBtnData.state === 6">
          立即购买<span v-if="price !== null" class="price"><b style="font-size: 80%;">¥</b>{{ price }}</span>
        </div>
        <div class="foot-box" @click="toBuy" v-if="buyBtnData.state !== 6">
          {{ buyBtnData.btnTxt }}<span class="price" v-if="price !== null && isShowPrice(buyBtnData.state)"><b
              style="font-size: 80%;">¥</b>{{ price }}</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { getBigNum, gioPlatform, beforePageNameMap } from '@/utils/tools';
import checkIcon from '@/assets/img/components/courseDetail/checkIcon.png';

import { reqPrice } from '@/api/pay';
import { reqCombinationAcvitity } from '@/api/combination'
import SelectCourseCard from './selectCourseCard.vue';
import { replaceHyphens } from '@/utils/tools';

export default {
  components: {
    SelectCourseCard,
  },
  data() {
    return {
      combinationId: this.$route.query.combinationId,
      checkIcon,
      show: true,
      mandatoryCourse: [], // 必须课程
      optionCourse: [], // 可选课程
      chooseNum: 2, // 可选择的数量
      selectCourse: [], // 选择的课程
      // disbaled: false,
      numList: [],
      price: null
    };
  },
  props: {
    buyBtnData: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    ...mapState(['courseBaseData']),
  },
  mounted() {
    this.initData();
  },
  methods: {
    onClose() {
      this.show = true;
      this.$emit('close', false);
    },
    isShowPrice(state) {
      return [4, 5, 7].includes(state)
    },
    showNum(num) {
      return getBigNum(num, 2);
    },
    chooseCourse(course, index, idx) {
      this.optionCourse[index].productSkuList[idx].isSelect = !course.isSelect;
      let num = 0;
      this.optionCourse.forEach((item) => {
        item.productSkuList.forEach((child) => {
          // 同产品不同sku 互斥
          if (
            child.isSelect &&
            child.productId === course.productId &&
            child.productSkuId !== course.productSkuId
          ) {
            Object.assign(child, { isSelect: false });
          }
        });
        // 当前组超过可选数量置灰
        num = item.productSkuList.filter((child) => child.isSelect).length;
        Object.assign(item, { disbaled: item.groupInfo.selectProductNum === num });
      });
      this.resetPrice()
    },
    skuInfo(data) {
      const { selectSkuInfo } = data;
      this.mandatoryCourse.forEach((item) => {
        if (item.productId === data.productId) {
          Object.assign(item, {
            productSkuId: selectSkuInfo.skuId,
          });
        }
      });
      this.resetPrice()
    },
    // 订单
    jumpPayOrder(course) {
      this.$sendToApp('hiddenShareButton', { showShare: 0 }, false);
      const query = JSON.stringify(
        course.map((product) => ({
          productId: product.productId,
          skuId: product.productSkuId,
          packageGroupId: product.packageGroupId,
          packageId: product.packageId,
        })),
      );
      // window.location.href = `${window.location.origin}/ark/payOrder?product=${query}&packageId=${this.combinationId}`;
      const { liveRoomId } = this.$route.query;
      this.$router.push({
        path: '/payOrder',
        query: {
          product: query,
          packageId: this.combinationId,
          liveRoomId,
        },
      });
      this.gioDefault(course);
    },
    initData() {
      const { packageProductRespList, packageId, packageGroupWebRespList } = this.courseBaseData;
      (packageProductRespList || []).forEach((item) => {
        Object.assign(item, { packageId });
      });
      this.mandatoryCourse = packageProductRespList || [];
      const courses = [];
      (packageGroupWebRespList || []).forEach((element) => {
        const { groupId, groupProductNum, name, selectProductNum } = element;
        const productSkuList = [];
        const groupInfo = {};
        Object.assign(groupInfo, {
          groupId,
          groupProductNum,
          name,
          selectProductNum,
          num: 0,
        });
        element.packageProductWebRespList.forEach((course) => {
          const { isBuy, isExpire, isSoldOut, isOffline } = course;
          if (!isBuy && !isExpire && !isSoldOut && !isOffline) {
            course.packageProductSkuWebRespList.forEach((child) => {
              const skuSpecJson = JSON.parse(child.skuSpecJson);
              productSkuList.push({
                packageGroupId: groupId,
                packageId: this.combinationId,
                name: course.productName,
                productId: course.productId,
                productSkuId: child.skuId,
                skuName: child.isDefault ? [] : skuSpecJson.map((item) => item.value),
                isSelect: false,
                disaled: !(
                  (child.isSetStock === 1 && child.availableStock) ||
                  child.isSetStock === 0
                ),
              });
            });
          }
        });
        courses.push({ productSkuList, groupInfo });
      });
      this.optionCourse = courses;
    },

    async resetPrice() {
      let flag = true;
      let groupCourse = [];
      this.optionCourse.forEach((item) => {
        const { productSkuList, groupInfo } = item;
        Object.assign(productSkuList, { groupId: groupInfo.groupId });
        const course = productSkuList.filter((list) => list.isSelect);
        groupCourse = [...groupCourse, ...course];
        if (course.length !== groupInfo.selectProductNum) {
          flag = false;
        }
      });
      if (this.courseBaseData.priceType === 2 && flag) {
        const course = [...groupCourse, ...this.mandatoryCourse]
        const query = course.map((product) => ({
          productId: product.productId,
          skuId: product.productSkuId,
        }))
        if (!query.every(item => item.skuId)) return
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
        });
        try {
          // const { data } = await reqPrice({
          //   promotionBasicPrice: {
          //     endPoint: this.$root.$data.isApp ? 2 : 3,
          //     platform: 1,
          //   },

          //   promotionProductPackageReqList: [
          //     {
          //       packageId: Number(this.combinationId),
          //       packageProductSkuReqList: query,
          //     },
          //   ],
          // })
          const res = await reqCombinationAcvitity({
            company: 0,
            fitEndPoint: 1,
            packageId: Number(this.combinationId),
            packageProductSkuReqList: query,
          })
          let activeType = 0
          let nowAcvitity = {}
          console.log(res)
          this.currentTime = res.currentTime
          ? new Date(replaceHyphens(res.currentTime)).getTime()
          : new Date().getTime();
           const { packageDetailSinglePromotionResp, packageDetailCouponPromotionResp, sellPrice } = res.data;
          // ------------------秒杀,折后价
          if (packageDetailSinglePromotionResp && packageDetailSinglePromotionResp.startTime) {
            let state = 0;
            activeType = packageDetailSinglePromotionResp.promotionLabel;
            if (
              packageDetailSinglePromotionResp.showTime
              && new Date(replaceHyphens(packageDetailSinglePromotionResp.showTime)).getTime()
              > this.currentTime
            ) {
              // 未到活动展示时间
              activeType = 0;
            } else if (
              new Date(replaceHyphens(packageDetailSinglePromotionResp.startTime)).getTime()
              > this.currentTime
            ) {
              // 未开始
              state = 0;
            } else {
              // 进行中
              state = 1;
            }
            nowAcvitity = packageDetailSinglePromotionResp;
            Object.assign(packageDetailSinglePromotionResp, {
              state,
            });
          } else {
            activeType = 0;
          }
          // console.log(activeType)
          // ----------------------优惠券 免费课不展示券后价格
          if (
            activeType === 0
            && sellPrice
          ) {
            let temp = {}
            if (packageDetailCouponPromotionResp) {
              temp = packageDetailCouponPromotionResp
            }
            Object.assign(temp, {
              price: sellPrice,
              promotionPrice: (
                sellPrice - (packageDetailCouponPromotionResp?.couponDiscount || 0)
              ).toFixed(2),
            });
            activeType = 4;
            nowAcvitity = temp;
          }
          console.log(11111,{nowAcvitity, activeType})
          if (activeType === 1) {
            this.price = nowAcvitity.state === 0 ? nowAcvitity.price : nowAcvitity.promotionPrice
          }  else if (activeType === 2 || activeType === 3) {
             this.price = nowAcvitity.state === 0 ? nowAcvitity.price : nowAcvitity.promotionPrice
          } else if (activeType === 4) {
            this.price =  nowAcvitity.promotionPrice
          } else {
            this.price =  ''
          }
          // this.price = data.orderPayPrice
          this.$toast.clear();
        } catch (e) {
          this.$toast.clear();
        }
      } else {
        this.price = null
      }

    },
    toBuy() {
      let flag = true;
      let groupCourse = [];
      this.optionCourse.forEach((item) => {
        const { productSkuList, groupInfo } = item;
        Object.assign(productSkuList, { groupId: groupInfo.groupId });
        const course = productSkuList.filter((list) => list.isSelect);
        groupCourse = [...groupCourse, ...course];
        if (course.length !== groupInfo.selectProductNum) {
          flag = false;
        }
      });
      if (flag) {
        this.jumpPayOrder([...groupCourse, ...this.mandatoryCourse]);
      } else {
        this.$toast('请选择课程');
      }
    },
    async gioDefault(course) {
      const res = await reqPrice({
        promotionBasicPrice: {
          endPoint: this.$root.$data.isApp ? 2 : 3,
          platform: 1,
        },
        promotionProductPackageReqList: [
          {
            packageId: Number(this.combinationId),
            packageProductSkuReqList: course.map((product) => ({
              productId: product.productId,
              skuId: product.productSkuId,
              packageGroupId: product.packageGroupId,
              packageId: product.packageId,
            })),
          },
        ],
      });
      if (res.code === 0) {
        const courseIdList = [];
        const courseNameList = [];
        const allianceId = [];
        const allianceName = [];
        const fullReductionId = [];
        const fullReductionName = [];
        const secondsKillNameList = [];
        const {
          orderPayPrice,
          orderTotalPrice,
          productPackageCalculateResultRespList,
          fullDiscountPrice,
          unionDiscountPrice,
          unionCalculateResultRespList,
          promotionFullCalculateResultRespList,
          singleCalculateResultRespList,
        } = res.data;
        // 注：套餐与普通字段不同取productPackageCalculateResultRespList
        if (productPackageCalculateResultRespList) {
          productPackageCalculateResultRespList[0].packageDetailCalculateResultRespList.forEach(
            (element) => {
              courseIdList.push(element.productId);
              courseNameList.push(element.productName);
            },
          );
        }
        if (unionDiscountPrice) {
          unionCalculateResultRespList.forEach((element) => {
            allianceId.push(element.promotionId);
            allianceName.push(element.promotionName);
          });
        }
        if (fullDiscountPrice) {
          promotionFullCalculateResultRespList.forEach((element) => {
            fullReductionId.push(element.promotionId);
            fullReductionName.push(element.promotionName);
          });
        }
        if (singleCalculateResultRespList) {
          singleCalculateResultRespList.forEach((element) => {
            if (element.promotionLabel === 2 || element.promotionLabel === 3) {
              secondsKillNameList.push(element.promotionName);
            }
          });
        }
        // 立即购买埋点
        const miniBeforePageName = window.localStorage.getItem('miniBeforePageName');
        const beforePage = miniBeforePageName || this.$route.query.beforePageName;

        // eslint-disable-next-line
        gio('track', 'buyCourse_event', {
          courseIdList_var: courseIdList.toString(), // 课程 ID 列表
          courseNameList_var: courseNameList.toString(), // 课程名称列表
          courseTotalPrice_var: secondsKillNameList.length > 0 ? orderPayPrice : orderTotalPrice, // 课程总价
          isAlliance_var: unionDiscountPrice ? '是' : '否', // 是否参加联报
          allianceId_var: unionDiscountPrice ? allianceId.toString() : null, // 联报活动ID
          allianceName_var: unionDiscountPrice ? allianceName.toString() : null, // 联报活动名称
          allianceDiscountAmount_var: unionDiscountPrice || null, // 联报优惠金额
          isSecondsKill_var: secondsKillNameList.length > 0 ? '是' : '否', // 是否参加秒杀
          secondsKillNameList_var:
            secondsKillNameList.length > 0 ? secondsKillNameList.toString() : null, // 秒杀活动名称列表
          isFullReduction_var: fullDiscountPrice ? '是' : '否', // 是否参加满减
          fullReductionId_var: fullDiscountPrice ? fullReductionId.toString() : null, // 满减活动ID
          fullReductionName_var: fullDiscountPrice ? fullReductionName.toString() : null, // 满减活动名称
          fullReductionAmount_var: fullDiscountPrice || null, // 满减优惠金额
          platform_var: gioPlatform(),
          beforePageName_var: beforePageNameMap(beforePage),
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-popup {
  overflow-y: hidden;
  border-radius: 16px 16px 0 0;
}

.title {
  position: relative;
  width: 100%;
  height: 130px;
  padding: 40px 0 0 0;
  background: #f9f9f9;

  >p {
    color: #333;
    font-weight: 600;
    font-size: 36px;
    text-align: center;
  }
}

::v-deep .van-icon {
  position: absolute;
  top: 18px;
  right: 30px;
  font-size: 24px;
}

.content {
  height: 1050px;
  padding-bottom: 120px;
  overflow: hidden;

  .content-box {
    height: 100%;
    padding-bottom: 120px;
    overflow-y: auto;
  }
}

.mandatory {

  // height: 10000px;
  // border-bottom: 20px solid #f9f9f9;
  .mandatory-box {
    border-bottom: 20px solid #f9f9f9;
  }
}

.optional {
  padding: 40px;

  .group-name {
    // height: 100px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 32px;

    p {
      width: 100%;
      padding: 0 0 12px 0;
      color: #333;
      font-weight: 600;
      font-size: 32px;
      line-height: 44px;
    }

    span {
      color: #333;
      font-weight: 400;
      font-size: 28px;
      line-height: 40px;
    }
  }

  .optional-course {
    li {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      width: 678px;
      height: 105px;
      margin-bottom: 24px;
      padding: 20px;
      background: #fff;
      border: 2px solid #e8e8e8;
      border-radius: 4px;

      p {
        width: 100%;
        color: #333;
        font-weight: 600;
        font-size: 24px;
      }

      span {
        color: #787878;
        font-size: 24px;
      }

      img {
        display: none;
      }
    }

    li.disbaled {
      background: #f9f9f9;
      // opacity: 0.5;
      pointer-events: none;

      p,
      span {
        color: #c8c8c8;
      }
    }

    li.active {
      background: #fff5ed;
      border: 2px solid #ff6c02;
      border-radius: 4px;

      img {
        position: absolute;
        right: 0;
        bottom: -1px;
        display: block;
        width: 29px;
      }

      p,
      span {
        color: #ff6c02;
      }
    }
  }
}

.foot {
  position: fixed;
  bottom: 0;
  z-index: 200;
  width: 750px;
  height: 120px;
  padding: 20px 0 0 0;
  background: #fefffe;
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.05);

  >div {
    width: 678px;
    height: 82px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 82px;
    text-align: center;
    background: #ff6c02;
    border-radius: 41px;
  }

  .price {
    display: inline-block;
    margin-left: 8px;
    font-size: 29px
  }
}
</style>
